import { useT } from "@/lib/i18n";
import { cn } from "@/lib/util";
import { Languages } from "lucide-react";

/**
 * Compact ES/EN toggle for the top header bar.
 */
export function LanguageToggle() {
  const { locale, setLocale, t } = useT();
  return (
    <div
      className="inline-flex items-center border border-border overflow-hidden"
      role="group"
      aria-label={t("lang.toggle_aria")}
      data-testid="language-toggle"
    >
      <Languages className="w-3 h-3 text-muted-foreground mx-2" />
      {["es", "en"].map((l) => (
        <button
          key={l}
          type="button"
          onClick={() => setLocale(l)}
          className={cn(
            "font-mono text-[10px] tracking-widest uppercase px-2 py-1 transition-colors",
            locale === l
              ? "bg-primary/15 text-primary"
              : "text-muted-foreground hover:text-foreground hover:bg-muted/40"
          )}
          data-testid={`lang-btn-${l}`}
          aria-pressed={locale === l}
        >
          {t(`lang.${l}`)}
        </button>
      ))}
    </div>
  );
}
